import React, { useState, useEffect } from 'react';
import TaskForm from 'features/projects/components/TaskForm';
import { TaskCard } from 'features/projects/components/TaskItem';
import { useLayout } from 'shared/contexts/LayoutContext';
import { useStateContext } from 'shared/contexts/ContextProvider';
import { PlusCircle } from 'lucide-react';
import { projectService, taskService } from 'features/projects/api';

const ProjectItem = ({ project}) => {
  const [tasks, setTasks] = useState([]);
  const [loading, setLoading] = useState(true);
  const { openModal, closeModal } = useLayout();
  const { showToast, token } = useStateContext();

  const addTask = (newTask) => {
    setTasks(currentTasks => [newTask, ...currentTasks]);
  };

  const updateTask = (updatedTask) => {
    console.log('updatedTask', updatedTask);
    setTasks(currentTasks => 
        currentTasks.map(task => 
            task.id === updatedTask.id ? updatedTask : task
        )
    );
  };

  const removeTask = (taskId) => {
    setTasks(currentTasks => currentTasks.filter(task => task.id !== taskId));
  };


  const fetchTasks = async () => {
    try {
      const projectTasks = await projectService.getTasks(project.id, '', '', token);
      setTasks(projectTasks.response.rows || []);
    } catch (error) {
      console.error('Error fetching tasks:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleAddTask = () => {
    openModal({
      component: <TaskForm projectId={project.id} afterSave={(task)=>addTask(task)}/>,
      title: 'Add Task',
      type: 'right',
      confirmCloseText: 'Are you sure you want to close? All unsaved changes will be lost.',
    });
  };


  useEffect(() => {
    fetchTasks();
  }, [project.id]);

  const handleStatusChange = async (taskId, newStatus) => {
    try {
      const response = await taskService.updateStatus(taskId, newStatus, token);

      console.log('handleStatusChange', response);
      if (response.status === 1) {
        showToast({
          title: 'Error',
          content: response.message || 'Error updating task status',
          type: 'error',
        });
        return;
      }
      showToast({
        title: 'Success',
        content: 'Task status updated successfully',
        type: 'success',
      });


      setTasks(tasks.map(task => 
        task.id === taskId ? { ...task, status: newStatus } : task
      ));
    } catch (error) {
      console.error('Error updating task status:', error);
    }
  };

  if (loading) {
    return (
      <div className='bg-white rounded-lg shadow-md p-4 h-[calc(100vh-4rem)]'>
        <div className='animate-pulse'>
          <div className='h-6 bg-gray-200 rounded w-3/4 mb-4'></div>
          <div className='space-y-3'>
            <div className='h-20 bg-gray-100 rounded'></div>
            <div className='h-20 bg-gray-100 rounded'></div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className='bg-white rounded-lg shadow-md flex flex-col h-[calc(100vh-16rem)]'>
      <div className='p-3 border-b flex-none'>
        <h2 className='text-lg font-semibold truncate'>{project.name}</h2>
        <p className='text-sm text-gray-600 mt-1 line-clamp-2'>{project.text}</p>
      </div>

      <div 
        className='flex-1 overflow-y-auto min-h-0 p-3 space-y-2 scrollbar-thin scrollbar-track-gray-100 scrollbar-thumb-gray-300 hover:scrollbar-thumb-gray-400'
        style={{ scrollbarWidth: 'thin', scrollbarColor: '#d4d4d4 #f3f4f6' }}
      >
        {tasks.map(task => (
          <TaskCard 
            key={task.id} 
            task={task} 
            onStatusChange={handleStatusChange}
            addTask={addTask}
            updateTask={updateTask}
            removeTask={removeTask}
          />
        ))}
      </div>

      <div className='p-3 border-t flex-none mt-auto'>
        <button 
          className='w-full flex items-center justify-center gap-2 py-2 text-sm text-white bg-blue-500 rounded-md hover:bg-blue-600 transition-colors'
          onClick={handleAddTask}
        >
          <PlusCircle className='w-4 h-4' />
          Add Task
        </button>
      </div>
    </div>
  );
};


export default ProjectItem;